import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'components/Modal/Modal';

import ButtonWithLoader from 'components/ButtonWithLoader/ButtonWithLoader';

import styles from './CloseJobModal.module.scss';

const CloseJobModal = ({ show, onCancel, onConfirm, isClosing }) => {
  return (
    <Modal closeButton show={show} title="Close Job" onExit={onCancel}>
      <div className={styles.modalContent}>
        <p className={styles.modalText}>
          Are you sure you want to close this job? This will stop new
          applications.
        </p>
        <div className={styles.modalActions}>
          <ButtonWithLoader
            bsStyle="default"
            onClick={onCancel}
            disabled={isClosing}
            loading={false}
            text="Cancel"
          />
          <ButtonWithLoader
            bsStyle="danger"
            onClick={onConfirm}
            disabled={isClosing}
            loading={isClosing}
            text="Close Job"
          />
        </div>
      </div>
    </Modal>
  );
};

CloseJobModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isClosing: PropTypes.bool.isRequired,
};

export default CloseJobModal;
